import { useMemo } from 'react';

/**
 * O selectbox de profissionais só traz os ativos. Quando a consulta em edição aponta para um
 * profissional que já foi desativado, ele não existe mais na lista e o campo apareceria em branco.
 * Aqui devolvemos as opções do selectbox acrescidas desse profissional, marcado como `inactive`,
 * apenas para que o nome continue sendo exibido — ele não deve ser selecionável.
 */
export function useProfessionalOptions(professionals, appointment) {
  return useMemo(() => {
    const professionalId = appointment?.dentistaId;

    if (!professionalId) {
      return professionals;
    }

    const isStillActive = professionals.some((professional) => professional.id === professionalId);

    if (isStillActive) {
      return professionals;
    }

    return [
      ...professionals,
      {
        id: professionalId,
        nome: appointment.nomeDoDentista ?? '',
        roomId: appointment.roomId ?? null,
        inactive: true,
      },
    ];
  }, [professionals, appointment]);
}

export const professionalOptionLabel = (option) => {
  if (!option?.nome) {
    return '';
  }
  return option.inactive ? `${option.nome} (inativo)` : option.nome;
};
